export default __webpack_public_path__ + "static/media/bg-home.15bbbf50.jpg";